import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
// import Link from "@material-ui/core/Link";

const styles = {
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
};

const Vinyl = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h5">Vinyl Cutter</Typography>
      <Typography variant="h6">Know Your Machine</Typography>
      <Typography variant="h5">Mango Double Layer</Typography>
      <Typography className={classes.para} paragraph>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./vinyl/mango_yello.jpg"
            alt="gimp"
          />
        </div>
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./vinyl/mango_wip.jpg" alt="gimp" />
        </div>
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./vinyl/mango_bnw.jpg" alt="gimp" />
        </div>
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./vinyl/mango_3d.jpg" alt="gimp" />
        </div>
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./vinyl/mango_ord.jpg" alt="gimp" />
        </div>
      </Typography>
    </div>
  );
};

export default withStyles(styles)(Vinyl);
